export default {"src":"/_next/static/media/logo-autopass-for-insurance.fbd40c5d.svg","height":15,"width":104,"blurWidth":0,"blurHeight":0};